module.exports = __webpack_public_path__ + "media/images/brands/lilica_e_tigor_page-2eb354abc352bb4e62e254038b77c685.png";